import React, { useState, useEffect } from "react";
import Autosuggest from "react-autosuggest";
import { getAirlineDetails } from "app/services/charterService";

const Carrier = ({ index, setFieldValue, initialValue }) => {
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  //  Auto-set value when editing
  useEffect(() => {
    if (initialValue && initialValue.flightCarrierName) {
      const result = {
        id: initialValue.id,
        label: `${initialValue.flightcarrierCode} ${initialValue.flightCarrierName}`,
      };
      setValue(result.label);
      setSuggestions(result);
      // Also ensure Formik has correct ID
      setFieldValue(
        `flightLegs.onward[${index}].flightCarrierId`,
        initialValue.id,
      );
    }
  }, [initialValue, index, setFieldValue]);

  // Fetch suggestions
  const getSuggestions = async (inputValue) => {
    if (!inputValue) return [];

    const data = await getAirlineDetails(inputValue);

    if (!data || data.Error) return [];

    return data.map((detail) => ({
      id: detail.id,
      label: `${detail.carrierCode} ${detail.carrierName}`,
    }));
  };

  const onSuggestionsFetchRequested = async ({ value }) => {
    const results = await getSuggestions(value);
    setSuggestions(results);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onChange = (event, { newValue }) => {
    setValue(newValue);

    // Reset carrier ID if user types manually
    setFieldValue(`flightLegs.onward[${index}].flightCarrierId`, "");
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    setValue(suggestion.label);

    setFieldValue(`flightLegs.onward[${index}].flightCarrierId`, suggestion.id);
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={(suggestion) => suggestion.label}
      renderSuggestion={(suggestion) => <div>{suggestion.label}</div>}
      onSuggestionSelected={onSuggestionSelected}
      inputProps={{
        placeholder: "Carrier",
        value,
        onChange,
        className: "form-control",
      }}
    />
  );
};

export default Carrier;
